import HeroHomepage from './hero-homepage'
interface HeroProps {
  title?: string
  subtitle?: string
}

const Hero = ({ title, subtitle }: HeroProps) => {
  return (

    <>
      <HeroHomepage title={title} subtitle={subtitle} bookDemoText={"Founder 1:1 Demo"}/> 
    </>
  )
}

export default Hero